<script setup>
import ResultsSummary from "./ResultsSummary.vue";
defineProps({
  priceDetails: {
    type: Object,
    required: true
  },
  isBoost: {
    type: Boolean,
    default: false
  },
  isDisabled: {
    type: Boolean,
    default: false
  }
});
</script>

<template>
    <div class="flex flex-col items-center justify-center text-center w-full">
        <span
            class="w-full text-xs 425:text-sm font-medium tracking-wider text-header-dark text-center pt-1 pb-4 px-4 425:px-1 uppercase"
        >
            {{ $t("simulation.charge.results.reduced_title") }}
        </span>
        <div
            class="w-full border border-secondary-gray-disabled bg-white rounded-lg 425:rounded-2xl items-center justify-center p-4 425:p-6"
        >
            <ResultsSummary :price-details :is-boost :is-disabled />
        </div>
    </div>
</template>
